import React, { useState, useEffect } from 'react';
import { NavLink, useParams, useNavigate} from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import { savePermisosPaginas, getPermisosPaginas } from './../Utils/indexedDBUtils';
import { Accordion, Card, CardBody, CardHeader, Row, Col } from 'react-bootstrap';

export default function Reportes(){
    const navigate = useNavigate();
    const { token, rol, user, fetchPermisosPaginas } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [swalProps, setSwalProps] = useState();
    const [permisosPaginas, setPermisosPaginas] = useState([]);
    const [anioSemanaSeleccionado, setAnioSemanaSeleccionado] = useState('');
    const [anioAnualSeleccionado, setAnioAnualSeleccionado] = useState('');
    const [listadoReportesSemanal, setListadoReportesSemanal] = useState([]);
    const [listadoReportesMensual, setListadoReportesMensual] = useState([]);
    const [listadoReportesAnual, setListadoReportesAnual] = useState([]);
    const [anioSemanaSeleccionadoMensual, setAnioSemanaSeleccionadoMensual] = useState('');
    const consultarPermisosPaginas = React.useCallback(async () => {
        const cachedPermisos = await getPermisosPaginas();
        if (cachedPermisos) {
            setPermisosPaginas(cachedPermisos);
        } else {
            // If not in IndexedDB, fetch from the API
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                setPermisosPaginas(permisos);
                await savePermisosPaginas(permisos); // Save the result to IndexedDB
            }
        }
    }, [fetchPermisosPaginas]);
    useEffect(() => {
        consultarPermisosPaginas();
    }, [consultarPermisosPaginas]);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function ConsultarLisadoReportesSemanal(anio){
        setCargando(true);
        const url = '/diagnostico/reportes/listarreportesemanal/' + anio;
        await apiService.get(url, token)
        .then((response) => {
            setCargando(false);
            setListadoReportesSemanal(response.data);
        })
        .catch((error) => {
            setCargando(false);
            console.error('Error fetching weekly reports list:', error);
            Mensaje('Error', 'Hubo un error al consultar el listado de reportes semanales.');
        });
    }
    async function ConsultarLisadoReportesMensual(anio){
        setCargando(true);
        const url = '/diagnostico/reportes/listarreportesmensual/' + anio;
        await apiService.get(url, token)
        .then((response) => {
            setCargando(false);
            setListadoReportesMensual(response.data);
        })
        .catch((error) => {
            setCargando(false);
            console.error('Error fetching monthly reports list:', error);
            Mensaje('Error', 'Hubo un error al consultar el listado de reportes mensuales.');
        });
    }
    async function ConsultarLisadoReportesAnual(anio){
        setCargando(true);
        const url = '/diagnostico/reportes/listarreporteanual/' + anio;
        await apiService.get(url, token)
        .then((response) => {
            setCargando(false);
            setListadoReportesAnual(response.data);
        })
        .catch((error) => {
            setCargando(false);
            console.error('Error fetching annual reports list:', error);
            Mensaje('Error', 'Hubo un error al consultar el listado de reportes anuales.');
        });
    }

    
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = 2025; year <= currentYear; year++) {
        years.push(year);
    }

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Reportes</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                                <li className="breadcrumb-item active"> Reportes</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                    </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <Card>
                                <CardHeader>
                                    <h3 className="card-title">Reporte diagnóstico semanal</h3>
                                </CardHeader>
                                <CardBody>
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Generar, revisar y guardar el informe semanal.</Accordion.Header>
                                            <Accordion.Body>
                                                <NavLink to="/caracterizacion/generarreportesemana/0" className="btn btn-primary" role="button" aria-label="Informe semanal">
                                                    Generar informe semanal
                                                </NavLink>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>Ver el informe semanal.</Accordion.Header>
                                            <Accordion.Body>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="input-group mb-3">
                                                            <select
                                                                className="form-select" 
                                                                aria-label="Seleccionar año"
                                                                value={anioSemanaSeleccionado}
                                                                onChange={(e) => setAnioSemanaSeleccionado(e.target.value)}>
                                                                <option value="">Seleccione un año</option>
                                                                {years.map((year) => (
                                                                    <option key={year} value={year}>{year}</option>
                                                                ))}
                                                            </select>
                                                            <button 
                                                                className="btn btn-outline-secondary" 
                                                                type="button"
                                                                onClick={() => ConsultarLisadoReportesSemanal(anioSemanaSeleccionado)}>
                                                                <i className="fas fa-search"></i> Buscar
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-hover">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Id</th>
                                                                        <th>Inicio semana actual</th>
                                                                        <th>Fin semana actual</th>
                                                                        <th>Inicio semana anterior</th>
                                                                        <th>Fin semana anterior</th>
                                                                        <th>Acciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {listadoReportesSemanal.map((reporte) => (
                                                                        <tr key={reporte.id}>
                                                                            <td>{reporte.id}</td>
                                                                            <td>{reporte.datcurrstart}</td>
                                                                            <td>{reporte.datcurrend}</td>
                                                                            <td>{reporte.datprevstart}</td>
                                                                            <td>{reporte.datprevend}</td>
                                                                            <td>
                                                                                <NavLink 
                                                                                    to={`/caracterizacion/reportesemana/${reporte.id}`} 
                                                                                    className="btn btn-primary" 
                                                                                    role="button" 
                                                                                    aria-label={`Ver informe semanal semana ${reporte.semana}`}>
                                                                                    Ver informe
                                                                                </NavLink>
                                                                                <NavLink 
                                                                                    to={`/caracterizacion/generarreportesemana/${reporte.id}`} 
                                                                                    className="btn btn-primary" 
                                                                                    role="button" 
                                                                                    aria-label={`Editar informe semanal semana ${reporte.semana}`}>
                                                                                    Editar informe
                                                                                </NavLink>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Card>
                                <CardHeader>
                                    <h3 className="card-title">Reporte diagnóstico mensual</h3>
                                </CardHeader>
                                <CardBody>
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Generar, revisar y guardar el informe mensual.</Accordion.Header>
                                            <Accordion.Body>
                                                <NavLink to="/caracterizacion/generarreportemensual/0" className="btn btn-primary" role="button" aria-label="Informe mensual">
                                                    Generar informe mensual
                                                </NavLink>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>Ver el informe mensual.</Accordion.Header>
                                            <Accordion.Body>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="input-group mb-3">
                                                            <select
                                                                className="form-select" 
                                                                aria-label="Seleccionar año"
                                                                value={anioSemanaSeleccionadoMensual}
                                                                onChange={(e) => setAnioSemanaSeleccionadoMensual(e.target.value)}>
                                                                <option value="">Seleccione un año</option>
                                                                {years.map((year) => (
                                                                    <option key={year} value={year}>{year}</option>
                                                                ))}
                                                            </select>
                                                            <button 
                                                                className="btn btn-outline-secondary" 
                                                                type="button"
                                                                onClick={() => ConsultarLisadoReportesMensual(anioSemanaSeleccionadoMensual)}>
                                                                <i className="fas fa-search"></i> Buscar
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-hover">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Id</th>
                                                                        <th>Inicio mes actual</th>
                                                                        <th>Fin mes actual</th>
                                                                        <th>Inicio mes anterior</th>
                                                                        <th>Fin mes anterior</th>
                                                                        <th>Acciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {listadoReportesMensual.map((reporte) => (
                                                                        <tr key={reporte.id}>
                                                                            <td>{reporte.id}</td>
                                                                            <td>{reporte.datcurrstart}</td>
                                                                            <td>{reporte.datcurrend}</td>
                                                                            <td>{reporte.datprevstart}</td>
                                                                            <td>{reporte.datprevend}</td>
                                                                            <td>
                                                                                <NavLink 
                                                                                    to={`/caracterizacion/reportemensual/${reporte.id}`} 
                                                                                    className="btn btn-primary" 
                                                                                    role="button" 
                                                                                    aria-label={`Ver informe mensual mes ${reporte.mes}`}>
                                                                                    Ver informe
                                                                                </NavLink>
                                                                                <NavLink 
                                                                                    to={`/caracterizacion/generarreportemensual/${reporte.id}`} 
                                                                                    className="btn btn-primary"
                                                                                    role="button"
                                                                                    aria-label={`Editar informe mensual mes ${reporte.mes}`}>
                                                                                    Editar informe
                                                                                </NavLink>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Card>
                                <CardHeader>
                                    <h3 className="card-title">Reporte diagn&oacute;stico anual</h3>
                                </CardHeader>
                                <CardBody>
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Generar, revisar y guardar el informe anual.</Accordion.Header>
                                            <Accordion.Body>
                                                <NavLink to="/caracterizacion/generarreporteanual/0" className="btn btn-primary" role="button" aria-label="Informe anual">
                                                    Generar informe anual
                                                </NavLink>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>Ver el informe anual.</Accordion.Header>
                                            <Accordion.Body>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="input-group mb-3">
                                                            <select
                                                                className="form-select" 
                                                                aria-label="Seleccionar año"
                                                                value={anioAnualSeleccionado}
                                                                onChange={(e) => setAnioAnualSeleccionado(e.target.value)}>
                                                                <option value="">Seleccione un año</option>
                                                                {years.map((year) => (
                                                                    <option key={year} value={year}>{year}</option>
                                                                ))}
                                                            </select>
                                                            <button 
                                                                className="btn btn-outline-secondary" 
                                                                type="button"
                                                                onClick={() => ConsultarLisadoReportesAnual(anioAnualSeleccionado)}>
                                                                <i className="fas fa-search"></i> Buscar
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-hover">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Id</th>
                                                                        <th>Inicio mes actual</th>
                                                                        <th>Fin mes actual</th>
                                                                        <th>Inicio mes anterior</th>
                                                                        <th>Fin mes anterior</th>
                                                                        <th>Acciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {listadoReportesAnual.map((reporte) => (
                                                                        <tr key={reporte.id}>
                                                                            <td>{reporte.id}</td>
                                                                            <td>{reporte.datcurrstart}</td>
                                                                            <td>{reporte.datcurrend}</td>
                                                                            <td>{reporte.datprevstart}</td>
                                                                            <td>{reporte.datprevend}</td>
                                                                            <td>
                                                                                <NavLink 
                                                                                    to={`/caracterizacion/reporteanual/${reporte.id}`} 
                                                                                    className="btn btn-primary" 
                                                                                    role="button" 
                                                                                    aria-label={`Ver informe mensual mes ${reporte.mes}`}>
                                                                                    Ver informe
                                                                                </NavLink>
                                                                                <NavLink 
                                                                                    to={`/caracterizacion/generarreporteanual/${reporte.id}`} 
                                                                                    className="btn btn-primary"
                                                                                    role="button"
                                                                                    aria-label={`Editar informe anual ${reporte.anio}`}>
                                                                                    Editar informe
                                                                                </NavLink>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}